<template>
  <roe-error-message :field="tier.matching_amount">
    <roe-percent-input
      v-model="tier.$model.matching_amount"
    ></roe-percent-input>
    <label class="input-label-inside">%</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoePercentInput from "@/components/_shared/inputs/PercentInput";
export default {
  name: "RoeTierMatchingAmountInput",
  components: { RoePercentInput, RoeErrorMessage },
  props: {
    tier: Object
  }
};
</script>
